import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ typography, palette, spacing, variables }) => ({
  boxWrapper: {
    position: 'relative',
    fontFamily: typography.fontFamily,
    fontSize: 0,
    whiteSpace: 'nowrap',
    padding: `${variables?.spacingB} ${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingC}`,
    zIndex: 3,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  box: {
    '&.courier-selected': {
      zIndex: 2,
      transition: 'border 500ms ease-out',
      backgroundColor:`${palette?.jet?.contentDefault} !important`,
      border:`1px solid ${palette?.jet?.contentDefault} !important`,
      color:`${palette.jet?.containerDefault} !important`,
      animation: `$bounce 2s ease infinite`,
      '&::before': {
        background: `${palette?.jet?.contentDefault} !important`,
      },
      '& .jetFontIcon':{
        color:`${palette.jet?.containerDefault} !important`
      },
      '& .separator':{
        borderTop:`1px solid ${palette.jet?.containerDefault} !important`,
      },
    },
    '&.courier-backby': {
      zIndex: 2,
      transition: 'border 500ms ease-out',
      backgroundColor:palette?.jet?.supportBrand06,
      border:`1px solid ${palette?.jet?.supportBrand06}`,
      color:`${palette.jet?.containerDefault} !important`,
      animation: `$bounce 2s ease infinite`,
      '&::before': {
        background: palette?.jet?.supportBrand06,
      },
      '& .jetFontIcon':{
        color:`${palette.jet?.containerDefault} !important`
      },
      '& .separator':{
        borderTop:`1px solid ${palette.jet?.containerDefault} !important`,
      },
    },
    '&.order-status-ASSIGNED, &.order-status-DELIVERED':{
      '& .jetFontIcon':{
        color: palette?.jet?.interactiveBrand
      },
      '& .separator':{
        borderTop:`1px solid ${palette?.jet?.interactiveBrand}`,
      },
    },
    '&.order-status-IN_DELIVERY':{
      '& .jetFontIcon':{
        color: palette?.jet?.supportInfo
      },
      '& .separator':{
        borderTop:`1px solid ${palette?.jet?.supportInfo}`,
      },
    },
    '& .separator':{
      borderTop:`1px solid ${palette?.jet?.borderDefault}`,
      borderBottom:'0px',
      marginTop:variables?.spacingA,
      marginBottom:variables?.spacingA,
      height:'1px',
      '&.no-order':{
        borderTop:`1px solid ${palette.jet?.supportError}`
      },
    },
    '& .jetFontIcon':{
      color:palette?.jet?.supportBrand01,
      paddingRight:variables?.spacingA,
      fontWeight:'bold'
    },
    '&.inDelivery':{
      border:`1px solid ${palette.jet?.supportInfo} !important`
    },
    '&.delivered': {
      zIndex: 2,
      transition: 'border 500ms ease-out',
      backgroundColor:palette?.jet?.supportError02,
      border:`1px solid ${palette?.jet?.supportError02}`,
      color:`${palette.jet?.containerDefault}`,
      animation: `$bounce 2s ease infinite`,
      '&::before': {
        background: palette?.jet?.supportError02,
      },
      '& .jetFontIcon':{
        color:`${palette.jet?.containerDefault}`
      },
    },
    backgroundColor:`${palette.jet?.containerDefault}`,
    maxWidth:'180px',
    height:'53px',
    width: 'auto',
    boxShadow:variables?.elevation04,
    border:`1px solid ${palette.jet?.containerDefault}`,
    borderRadius:variables?.radiusRoundedA,
    position: 'relative',
    left: 'calc(-50% - 3px)',
    top: '-4px',
    paddingLeft:variables?.spacingB,
    paddingRight:variables?.spacingB,
    paddingTop:variables?.spacingA,
    paddingBottom:variables?.spacingA,
    '&::before': {
        width: '7px',
        height: '7px',
        content: "''",
        position: 'absolute',
        transform: 'rotate(45deg)',
        background: `${palette.jet?.containerDefault}`,
        boxShadow: 'none',
        boxSizing: 'border-box',
        borderRight: 'inherit',
        borderBottom: 'inherit',
        left:'50%',
        bottom: '-4px'
    },
    '& p': {
      fontSize: '0.6875rem',
      lineHeight: 1.272727,
      margin: 0,
    },
  },
  justify_center:{
    display:'flex',
    justifyContent:'center',
    align:'center'
  },
  boxItem: {
    display:'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  boxMarkerText: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign:'center'
  },
  customerName:{
    textOverflow:'ellipsis',
    display:'block',
    whiteSpace:'nowrap',
    overflow:'hidden'
  }
}));

export default styles;
